@mixin tip($direction: 'left', $size: 5px, $color: currentColor) {
  width: 0;
  height: 0;
  position: absolute;
  display: block;
  content: ' ';

  z-index: -1;
  @if $direction == 'left' {
    border-top: $size solid transparent;
    border-bottom: $size solid transparent;
    border-right: $size solid $color;
    left: var(--p-size-static-0125);
    top: 50%;
    transform: translateX(-100%) translateY(-50%);
  }
  @if $direction == 'right' {
    border-top: $size solid transparent;
    border-bottom: $size solid transparent;
    border-left: $size solid $color;
    right: var(--p-size-static-0125);
    top: 50%;
    transform: translateX(100%) translateY(-50%);
  }
  @if $direction == 'up' {
    border-left: $size solid transparent;
    border-right: $size solid transparent;
    border-bottom: $size solid $color;
    left: 50%;
    top: 0;
    transform: translateX(-50%) translateY(-100%);
  }
  @if $direction == 'down' {
    border-left: $size solid transparent;
    border-right: $size solid transparent;
    border-top: $size solid $color;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%) translateY(100%);
  }
}

:host {
  position: absolute;
  max-width: 300px;
  width: max-content;
  top: 0;
  left: 0;
  box-sizing: border-box;
  pointer-events: none;
  &.open {
    pointer-events: inherit;
  }
}
.anchor-c-tooltip {
  &:not(.open) {
    pointer-events: none;
  }
  visibility: hidden;
  &.open {
    visibility: visible;
  }
  min-width: 100px;
  max-width: 40vw;
  $bg: var(--s-color-background-contrast);
  $triangleSize: var(--p-size-static-050);
  background-color: $bg;
  color: var(--s-color-text-on-dark-default);
  padding: var(--p-size-static-100) var(--p-size-static-050);
  position: relative;
  $tipSize: var(--p-size-static-050);
  margin: var(--p-size-static-100) var(--p-size-static-050);
  &.position-bottom {
    &::before {
      @include tip('up', $tipSize, $bg);
    }
  }
  &.position-left {
    &::before {
      @include tip('right', $tipSize, $bg);
    }
  }
  &.position-right {
    &::before {
      @include tip('left', $tipSize, $bg);
    }
  }
  &.position-top {
    &::before {
      @include tip('down', $tipSize, $bg);
    }
  }
}
